import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  max-width: 100%;
  overflow-x: auto;
  margin: 0;
  border-spacing: 0;
  border-collapse: collapse;
`;

export const TH = styled.th`
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  padding: 0.4rem;
`;
